/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  CustomizeAffiliateReferrerCodeOptions,
  CustomizeAffiliateReferrerCodeResponses,
} from '../types/CustomizeAffiliateReferrerCode'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description The owner of this affiliate membership may change its primary code once. ADMIN callers may change any membership's code repeatedly across tenants. Admin changes preserve the owner's remaining one-time change. Changes are allowed while the program is inactive. Its initial code, whether generated or chosen by an admin, does not count as the change. Previous codes remain aliases and cannot be reused; codes resolve only while the program is active. Codes are unique across all programs and tenants, including for admins.
 * @summary Change an affiliate referral code
 * {@link /v1/affiliate_referrers/:referrer_id/code}
 */
export function customizeAffiliateReferrerCode<ThrowOnError extends boolean = true>(
  options: Options<CustomizeAffiliateReferrerCodeOptions, ThrowOnError>,
): Unwrappable<RequestResult<CustomizeAffiliateReferrerCodeResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/affiliate_referrers/{referrer_id}/code',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<CustomizeAffiliateReferrerCodeResponses, ThrowOnError>>,
  )
}
